/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface MemoCreationInput {
  /**
   * 메모를 생성할 대상 환자 ID
   * @example "66bc0b30c5e0dd33e0089d68"
   */
  hserviceID: string;
  /**
   * 메모 내용
   * @example "메모 내용"
   */
  content: string;
  /**
   * 메모 종류 - 2000 - 관리 방향 메모, 3001 - 서비스 매니저 메모
   * @example 2000
   */
  type: 2000 | 3001;
  /** 메모에 포함된 파일 ID 배열 */
  fileIDs?: string[];
}

export interface ApiResponse {
  /**
   * 응답 코드 (0=성공, 그 외=오류)
   * @default 0
   */
  code: number;
  /** 응답 데이터 */
  data: Record<string, any>;
  /** 응답 메시지. 응답 코드가 0이 아닌 경우 오류 메시지. */
  message: string;
}

export interface Memo {
  /**
   * 메모 ID
   * @example "64b771e9a2b662448c1fe82b"
   */
  _id: string;
  /** 대상 병원 ID */
  hospitalID?: string;
  /** 대상 서비스 ID */
  hserviceID: string;
  /** 대상 유저 ID */
  userID?: string;
  /** 작성자 ID */
  writerID: string;
  /** 메인 콘텐츠 */
  mainContent?: string;
  /** 서브 콘텐츠 */
  subContent?: string;
  /** 콘텐츠 */
  content: string;
  /**
   * 병원측에서의 읽음 여부
   * @default true
   */
  d_Unread?: boolean;
  /**
   * 매니저 측에서의 읽음 여부
   * @default true
   */
  n_Unread?: boolean;
  /**
   * 병원으로부터 작성된 메모 여부
   * @default true
   */
  fromDoctor: boolean;
  /**
   * 초기치료내역에 대한 메모 여부
   * @default false
   */
  isInitialTreatment?: boolean;
  /** 메모 종류 - 2000 - 관리 방향 메모, 3001 - 서비스 매니저 메모 */
  type: number;
  /** 대상 병원 이름 */
  hospitalName: string;
  /** 작성자 이름 */
  writerName: string;
  /** 최종 수정자의 ID */
  modifierID?: string;
  /** 최종 수정자의 이름 */
  modifierName?: string;
  /** 메모 내 이미지 파일ID 목록 */
  fileIDs?: string[];
  /** 메모 삭제 여부 */
  isRemoved?: boolean;
  /** 메모 고정 여부 */
  isPinned: boolean;
  /** pin 업데이트 된 날짜 */
  pinUpdatedAt?: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export type MemoWithFileID = Memo & {
  /** 메모 내 이미지 파일 목록 */
  fileIDs?: File[];
};

export interface File {
  /**
   * 파일 ID
   * @example "66aca461f8238a4fd30abe15"
   */
  _id: string;
  /** 파일의 소유자 ID */
  userID?: string;
  /**
   * 파일 타입
   * - 300: Image
   * - 400: Video
   * - 500: File
   */
  type: number;
  /** 파일 객체에 포함된 파일의 URL 배열 */
  paths: string[];
  /** 파일 별, S3 스토리지에 업로드 된 파일의 정보 객체 배열 */
  aws?: Record<string, any>[];
  /** 파일 만료일. 외부 연동 서비스일 경우에 존재 */
  expiredAt?: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export type ApiMemosElCreateData = ApiResponse & {
  data: Memo;
};

export interface ApiMemosElFindLastParams {
  /** 서비스 ID */
  hserviceID?: any;
  /** 스킵할 수 */
  skip?: number;
  /** 가져오고자 하는 길이 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: number;
  /** 정렬하고자 하는 방향 */
  way?: number;
}

export type ApiMemosElFindLastData = any;

export interface ApiMemosElFindManageCountParams {
  /** 서비스 ID */
  hserviceID?: any;
  /** 스킵할 수 */
  skip?: number;
  /** 가져오고자 하는 길이 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: number;
  /** 정렬하고자 하는 방향 */
  way?: number;
}

export type ApiMemosElFindManageCountData = any;

export interface ApiMemosElFindManageLastParams {
  /** 서비스 ID */
  hserviceID?: any;
  /** 스킵할 수 */
  skip?: number;
  /** 가져오고자 하는 길이 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: number;
  /** 정렬하고자 하는 방향 */
  way?: number;
}

export type ApiMemosElFindManageLastData = any;

export interface ApiMemosElFindManageParams {
  /** 서비스 ID */
  hserviceID?: any;
  /** 스킵할 수 */
  skip?: number;
  /** 가져오고자 하는 길이 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: number;
  /** 정렬하고자 하는 방향 */
  way?: number;
}

export type ApiMemosElFindManageData = any;

export interface ApiMemosElFindNurseCountParams {
  /** 서비스 ID */
  hserviceID?: any;
  /** 스킵할 수 */
  skip?: number;
  /** 가져오고자 하는 길이 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: number;
  /** 정렬하고자 하는 방향 */
  way?: number;
}

export type ApiMemosElFindNurseCountData = any;

export interface ApiMemosElFindNurseLastParams {
  /** 서비스 ID */
  hserviceID?: any;
  /** 스킵할 수 */
  skip?: number;
  /** 가져오고자 하는 길이 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: number;
  /** 정렬하고자 하는 방향 */
  way?: number;
}

export type ApiMemosElFindNurseLastData = any;

export interface ApiMemosElFindNurseParams {
  /** 서비스 ID */
  hserviceID?: any;
  /** 스킵할 수 */
  skip?: number;
  /** 가져오고자 하는 길이 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: number;
  /** 정렬하고자 하는 방향 */
  way?: number;
}

export type ApiMemosElFindNurseData = any;

export interface ApiMemosElFindParams {
  /** 환자 ID */
  hserviceID?: any;
  /** 스킵할 수 */
  skip?: number;
  /** 가져오고자 하는 길이 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향 */
  way?: number;
  /** 의사로부터 받은 메모인지 여부 */
  fromDoctor?: boolean;
  /** 메모 타입 - 2000-관리방향 메모, 3001-서비스 매니저 메모 */
  type?: number;
}

export type ApiMemosElFindData = ApiResponse & {
  data: MemoWithFileID[];
};

export interface ApiMemosElFindWithPinnedParams {
  /** 환자 ID */
  hserviceID?: any;
  /** 스킵할 수 */
  skip?: number;
  /** 가져오고자 하는 길이 */
  limit?: number;
  /** 의사로부터 받은 메모인지 여부 */
  fromDoctor?: boolean;
  /** 메모 타입 - 2000-관리방향 메모, 3001-서비스 매니저 메모 */
  type?: number;
}

export type ApiMemosElFindWithPinnedData = ApiResponse & {
  data: MemoWithFileID[];
};

export type ApiMemosElReadData = any;

export type ApiMemosElRemoveData = any;

export type ApiMemosElUpdatePinData = ApiResponse & {
  data: Memo;
};

export type ApiMemosElUpdateData = ApiResponse & {
  data: Memo;
};

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * No description
     *
     * @tags V3-Memo
     * @name ApiMemosElCreate
     * @summary 관리방향 또는 서비스 매니저 메모 생성
     * @request POST:/v3/api/memos/el/create
     * @secure
     * @response `200` `ApiMemosElCreateData` 생성된 메모 객체
     */
    apiMemosElCreate: (data: MemoCreationInput, params: RequestParams = {}) =>
      this.request<ApiMemosElCreateData, any>({
        path: `/v3/api/memos/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Memo
     * @name ApiMemosElFindLast
     * @summary 메모 조회
     * @request GET:/v3/api/memos/el/find/last
     * @secure
     * @response `200` `ApiMemosElFindLastData` \{Memo\} 모델 객체
     */
    apiMemosElFindLast: (query: ApiMemosElFindLastParams, params: RequestParams = {}) =>
      this.request<ApiMemosElFindLastData, any>({
        path: `/v3/api/memos/el/find/last`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Memo
     * @name ApiMemosElFindManageCount
     * @summary 메모 조회
     * @request GET:/v3/api/memos/el/find/manage/count
     * @secure
     * @response `200` `ApiMemosElFindManageCountData` \{Memo\} 모델 객체
     */
    apiMemosElFindManageCount: (query: ApiMemosElFindManageCountParams, params: RequestParams = {}) =>
      this.request<ApiMemosElFindManageCountData, any>({
        path: `/v3/api/memos/el/find/manage/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Memo
     * @name ApiMemosElFindManageLast
     * @summary 메모 조회
     * @request GET:/v3/api/memos/el/find/manage/last
     * @secure
     * @response `200` `ApiMemosElFindManageLastData` \{Memo\} 모델 객체
     */
    apiMemosElFindManageLast: (query: ApiMemosElFindManageLastParams, params: RequestParams = {}) =>
      this.request<ApiMemosElFindManageLastData, any>({
        path: `/v3/api/memos/el/find/manage/last`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Memo
     * @name ApiMemosElFindManage
     * @summary 메모 조회
     * @request GET:/v3/api/memos/el/find/manage
     * @secure
     * @response `200` `ApiMemosElFindManageData` \{Memo\} 모델 객체
     */
    apiMemosElFindManage: (query: ApiMemosElFindManageParams, params: RequestParams = {}) =>
      this.request<ApiMemosElFindManageData, any>({
        path: `/v3/api/memos/el/find/manage`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Memo
     * @name ApiMemosElFindNurseCount
     * @summary 메모 조회
     * @request GET:/v3/api/memos/el/find/nurse/count
     * @secure
     * @response `200` `ApiMemosElFindNurseCountData` \{Memo\} 모델 객체
     */
    apiMemosElFindNurseCount: (query: ApiMemosElFindNurseCountParams, params: RequestParams = {}) =>
      this.request<ApiMemosElFindNurseCountData, any>({
        path: `/v3/api/memos/el/find/nurse/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Memo
     * @name ApiMemosElFindNurseLast
     * @summary 메모 조회
     * @request GET:/v3/api/memos/el/find/nurse/last
     * @secure
     * @response `200` `ApiMemosElFindNurseLastData` \{Memo\} 모델 객체
     */
    apiMemosElFindNurseLast: (query: ApiMemosElFindNurseLastParams, params: RequestParams = {}) =>
      this.request<ApiMemosElFindNurseLastData, any>({
        path: `/v3/api/memos/el/find/nurse/last`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Memo
     * @name ApiMemosElFindNurse
     * @summary 메모 조회
     * @request GET:/v3/api/memos/el/find/nurse
     * @secure
     * @response `200` `ApiMemosElFindNurseData` \{Memo\} 모델 객체
     */
    apiMemosElFindNurse: (query: ApiMemosElFindNurseParams, params: RequestParams = {}) =>
      this.request<ApiMemosElFindNurseData, any>({
        path: `/v3/api/memos/el/find/nurse`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Memo
     * @name ApiMemosElFind
     * @summary 메모 조회
     * @request GET:/v3/api/memos/el/find
     * @secure
     * @response `200` `ApiMemosElFindData` 조회된 메모 객체
     */
    apiMemosElFind: (query: ApiMemosElFindParams, params: RequestParams = {}) =>
      this.request<ApiMemosElFindData, any>({
        path: `/v3/api/memos/el/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Memo
     * @name ApiMemosElFindWithPinned
     * @summary 상단 고정 메모를 1번으로 세팅한 메모 리스트 조회
     * @request GET:/v3/api/memos/el/find/with-pinned
     * @secure
     * @response `200` `ApiMemosElFindWithPinnedData` 조회된 메모 객체
     */
    apiMemosElFindWithPinned: (query: ApiMemosElFindWithPinnedParams, params: RequestParams = {}) =>
      this.request<ApiMemosElFindWithPinnedData, any>({
        path: `/v3/api/memos/el/find/with-pinned`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Memo
     * @name ApiMemosElRead
     * @summary 메모 읽음
     * @request POST:/v3/api/memos/el/read
     * @secure
     * @response `200` `ApiMemosElReadData` \{PushSetting\} 생성된 객체
     */
    apiMemosElRead: (
      data: {
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiMemosElReadData, any>({
        path: `/v3/api/memos/el/read`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Memo
     * @name ApiMemosElRemove
     * @summary 메모 삭제
     * @request POST:/v3/api/memos/el/remove
     * @secure
     * @response `200` `ApiMemosElRemoveData` \{PushSetting\} 생성된 객체
     */
    apiMemosElRemove: (
      data: {
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiMemosElRemoveData, any>({
        path: `/v3/api/memos/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Memo
     * @name ApiMemosElUpdatePin
     * @summary 메모 상단 고정 여부 수정
     * @request POST:/v3/api/memos/el/update/pin
     * @secure
     * @response `200` `ApiMemosElUpdatePinData` 수정된 메모 객체
     */
    apiMemosElUpdatePin: (
      data: {
        /** 메모 ID */
        _id: string;
        /** 메모 상단 고정 여부 */
        isPinned: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiMemosElUpdatePinData, any>({
        path: `/v3/api/memos/el/update/pin`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Memo
     * @name ApiMemosElUpdate
     * @summary 메모 수정
     * @request POST:/v3/api/memos/el/update
     * @secure
     * @response `200` `ApiMemosElUpdateData` 수정된 메모 객체
     */
    apiMemosElUpdate: (
      data: {
        /** 메모 ID */
        _id: string;
        /** 메모 상단 고정 여부 */
        isPinned?: boolean;
        /** 의사로부터 받은 메모인지 여부 */
        fromDoctor?: boolean;
        /** 메모 내용 */
        content?: string;
        /** 메모에 포함된 파일 ID 배열 */
        fileIDs?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiMemosElUpdateData, any>({
        path: `/v3/api/memos/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
